import { toast } from "sonner";
import { useEffect, useState } from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, LabelList } from "recharts";
import { TrendingUp } from "lucide-react";
import api, { formatError } from "@/lib/api";

const label = (m) => new Date(`${m}-01T00:00:00`).toLocaleDateString("en-GB", { month: "short", year: "2-digit" });

export default function IncomeChart({ month, onPick, refreshKey }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/income/monthly").then(({ data }) => setData(data.months)).catch((e) => { setData([]); toast.error(formatError(e.response?.data?.detail) || "Could not load income"); });
  }, [refreshKey]);
  if (!data) return null;
  const total = data.reduce((a, d) => a + d.total, 0);
  return (
    <div className="bg-slate-800 rounded-2xl border-2 border-slate-700 p-4 mb-5" data-testid="income-chart">
      <div className="flex items-center gap-2 mb-3">
        <TrendingUp size={18} className="text-emerald-300" />
        <p className="font-bold">Income — last 12 months</p>
        <span className="ml-auto text-sm text-slate-300" data-testid="income-chart-total">Rs {total.toLocaleString()} in total</span>
      </div>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 22, right: 8, left: 0, bottom: 0 }}>
            <XAxis dataKey="month" tickFormatter={label} stroke="#94a3b8" fontSize={12} tickLine={false} />
            <YAxis stroke="#94a3b8" fontSize={12} tickLine={false} axisLine={false} width={56} tickFormatter={(v) => `Rs ${v}`} />
            <Tooltip cursor={{ fill: "rgba(148,163,184,0.12)" }} contentStyle={{ background: "#0f172a", border: "1px solid #334155", borderRadius: 12 }}
              labelFormatter={label} formatter={(v, _n, p) => [`Rs ${v.toLocaleString()} · ${p.payload.count} payment(s)`, "Income"]} />
            <Bar dataKey="total" radius={[8, 8, 0, 0]} onClick={(d) => onPick(d.month || d.payload?.month)} className="cursor-pointer">
              {data.map((d) => <Cell key={d.month} fill={d.month === month ? "#FDE047" : "#3B82F6"} data-testid={`income-bar-${d.month}`} />)}
              <LabelList dataKey="total" position="top" fill="#e2e8f0" fontSize={11} formatter={(v) => (v ? v.toLocaleString() : "")} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
